import { Component, OnInit, OnDestroy, Input, Output, forwardRef, EventEmitter, ElementRef, } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Subscription, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { CustomerService } from './../../../api/customer.service';

@Component({
  selector: 'iv-company-contact-field',
  templateUrl: './company-contact-field.component.html',
  styleUrls: ['./company-contact-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyContactFieldComponent),
      multi: true,
    },
  ],
})
export class CompanyContactFieldComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() type: string;
  @Input() controlName: string;
  @Input() label: string;
  @Input() disabled = false;
  @Output() selectCustomer = new EventEmitter();
  @Output() showNotFoundMessage = new EventEmitter();

  suggestions: any[] = [];
  companyContactFieldSubscription$: Subscription;

  private innerValue: any;
  onTouchedCallback: () => void = () => {};
  onChangedCallback: (_: any) => void = () => {};

  constructor(
    private customerService: CustomerService,
    private elementRef: ElementRef
  ) {}

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangedCallback(v);
    }
  }

  writeValue(obj: any): void {
    if (obj !== this.innerValue) {
      this.innerValue = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.onChangedCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  innerModelChanged() {}

  ngOnInit() {
    this.getCompanyContactFieldSuggestions();
  }

  ngOnDestroy() {
    if (this.companyContactFieldSubscription$) {
      this.companyContactFieldSubscription$.unsubscribe();
    }
  }

  customerSelectionChange(event: any, customer: any) {
    if (!event.source.selected) {
      return;
    }
    this.selectCustomer.emit(customer);
    this.writeValue(customer.name1);
    this.suggestions = [];
    this.suggestions.push(customer);
  }

  getCompanyContactFieldSuggestions() {
    if (this.companyContactFieldSubscription$) {
      this.companyContactFieldSubscription$.unsubscribe();
    }

    const eventStream = fromEvent(this.elementRef.nativeElement, 'keyup').pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(() => this.customerService.searchAll(this.value))
    );

    this.companyContactFieldSubscription$ = eventStream.subscribe(
      (response) => {
        this.showNotFoundMessage.emit(response.count === 0 ? true : false);
        this.suggestions = response.results;
      }
    );
  }
}
